module.exports = __webpack_public_path__ + "img/icon-xingsuan-logo.2df297f8.png";